var map = {
	"./245.png": 4668,
	"./49.jpg": 526,
	"./9301.gif": 9925,
	"./Bytecore.gif": 9999,
	"./CopperOre.png": 3630,
	"./Cryptogolem.gif": 1837,
	"./IronOre.png": 1881,
	"./ManganeseOre.png": 7518,
	"./Txncleaver.gif": 8652,
	"./celestialbot142.png": 2031,
	"./celestialfighter559.jpg": 95,
	"./machinabot411.png": 279,
	"./machinafighter398.jpg": 6565,
	"./proxcoin.gif": 1940,
	"./proxcoin2.gif": 3842,
	"./satoshibot137.png": 2318,
	"./tellurianbot93.png": 7832,
	"./tellurianfighter171.jpg": 8139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9767;